export const PRINT_OPTIONS = [
  { value: 'waybills', title: 'Транспортная накладная' }
]
